module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"see_more":"더보기"}}')
  delete Component.options._Ctor
}
